/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import React from "react";

import { useState, useEffect } from "react";

import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";

import { useStoreon } from "storeon/react";

import t from "../../translations";
import { useProboSize } from "utils/probo";

const inputCss = css`
  width: 100px;
  .label-focused {
    color: #a8bb43 !important;
  }
  .underline:after {
    border-bottom-color: #728416;
  }
  > div {
    > div > p {
      margin-right: 7px;
      color: #666;
    }
    background: white;
    :before {
      border-color: #a8bb43;
      border-bottom-width: 3px;
    }
    > input {
      text-align: center;
      background: white;
    }
  }
`;

export const CrossWrap = styled.div`
  font-size: 16px;
  font-weight: bold;
  color: #aaa;
  position: relative;
  top: 7px;
`;

const SizeWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin: 15px 0;
  width: 100%;
`;

export const Input = (props) => {
  return (
    <TextField
      css={inputCss}
      InputProps={{
        endAdornment: <InputAdornment position="end">cm</InputAdornment>,
        classes: {
          underline: "underline",
        },
      }}
      InputLabelProps={{
        classes: {
          focused: "label-focused",
        },
      }}
      {...props}
    />
  );
};

const Size = (props) => {
  const { dispatch, canvas, editorType } = useStoreon(
    "canvas",
    "editorType",
    "isAdmin"
  );
  const [input, setInput] = useState({
    width: 75,
    height: 55,
  });
  const { lockedWidth, lockedHeight } = useProboSize();
  useEffect(
    (_) => {
      if (!canvas) return;
      const updateSize = (_) => {
        const width = parseFloat((canvas.cutW * 0.1).toFixed(2));
        const height = parseFloat((canvas.cutH * 0.1).toFixed(2));
        setInput({ width, height });
      };
      updateSize();
      canvas.on("cutzone:updated", updateSize);
      canvas.on("canvas:loaded", updateSize);
      return () => {
        canvas.off("cutzone:updated", updateSize);
        canvas.off("canvas:loaded", updateSize);
      };
    },
    [canvas]
  );

  const handleChange = (name) => (event) => {
    const i = { ...input };
    i[name] = event.target.value;
    setInput(i);
  };

  const updateSize = () => {
    let w = `${input.width}`.replace(",", ".");
    let h = `${input.height}`.replace(",", ".");
    const width = (parseFloat(w) * 10).toFixed(2);
    const height = (parseFloat(h) * 10).toFixed(2);
    dispatch("canvas/updateSize", { width, height });
  };

  const handleEnterPress = (e) => {
    if (e.key === "Enter") {
      updateSize();
    }
  };

  const handleFitPrintplate = () => {
    if (!canvas) {
      return;
    }
    let minHeight = 0;
    canvas
      .getObjects()
      .filter((o) => !o.excludeFromExport)
      .forEach((o) => {
        const objLowPoint = o.top + o.getScaledHeight();
        if (objLowPoint > minHeight) {
          minHeight = objLowPoint;
        }
      });
    const cutZone = canvas.cutZone;
    cutZone.updateSize(cutZone.width, Math.ceil(minHeight));
    cutZone.fitCutZone();
  };

  return (
    <React.Fragment>
      <SizeWrapper>
        <Input
          disabled={lockedWidth}
          label={t.width}
          value={input.width}
          onChange={handleChange("width")}
          onKeyPress={handleEnterPress}
        />
        <CrossWrap>x</CrossWrap>
        <Input
          disabled={lockedHeight}
          label={t.height}
          value={input.height}
          onChange={handleChange("height")}
          onKeyPress={handleEnterPress}
        />
        <Button
          variant="contained"
          color="secondary"
          onClick={updateSize}
          css={css`
            margin-top: 14px;
          `}
        >
          Update
        </Button>
      </SizeWrapper>
      {editorType === "printplate" && (
        <Button
          variant="contained"
          color="secondary"
          onClick={handleFitPrintplate}
          fullWidth
          css={css`
            margin-top: 14px;
          `}
        >
          Fit printplate
        </Button>
      )}
    </React.Fragment>
  );
};

export default Size;
